import { Create } from '@refinedev/mui'
import {
  Box,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import { useForm } from '@refinedev/react-hook-form'

export const OrgsCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    setValue,
    formState: { errors },
  } = useForm({
    refineCoreProps: {
      action: 'create',
      resource: 'orgs',
      errorNotification: (data, values, resource) => {
        const detail = data?.response?.data?.detail
        // Some 409s (duplicate org name) now carry a structured object
        // ({ code, org_name, org_uuid, already_member }) rather than a
        // plain string — fall back to a readable message for those instead
        // of stringifying the object into "[object Object]".
        const message =
          typeof detail === 'string'
            ? detail
            : detail?.code === 'duplicate_org_name'
              ? `Organisation already exists with this name (${detail.org_name})`
              : null
        if (message) {
          return {
            message: `Error: ${message}`,
            description: 'Something went wrong when adding an org',
            type: 'error',
          }
        }
        return {
          message: 'Something went wrong when adding an org',
          description: 'Unknown error occurred',
          type: 'error',
        }
      },
    },
  })

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: 'flex', flexDirection: 'column' }}
        autoComplete="off"
      >
        <TextField
          {...register('name', {
            required: 'This field is required',
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
        <TextField
          {...register('charities_number')}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Charities Number"
          name="charities_number"
        />
        <TextField
          {...register('description')}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Description"
          name="description"
          multiline
          minRows={4}
          maxRows={20}
        />
        <InputLabel id="payment-type-label" sx={{ mt: 2 }}>
          Payment Type
        </InputLabel>
        <Select
          labelId="payment-type-label"
          {...register('payment_type')}
          onChange={(event) => setValue('payment_type', event.target.value)}
          size="small"
          sx={{ width: '20%' }}
          defaultValue=""
        >
          <MenuItem value="">None</MenuItem>
          <MenuItem value="Stripe">Stripe</MenuItem>
          <MenuItem value="Invoice">Invoice</MenuItem>
        </Select>
      </Box>
    </Create>
  )
}
